<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <div style="color: #fccc66; line-height: 30px">近年总体产销量走势</div>
        <supply-trend></supply-trend>
        <div style="color: #fccc66; line-height: 30px">
          主要城市销售量（吨）
        </div>
        <supply-city-rank></supply-city-rank>
      </el-col>
      <el-col :span="12">
        <div style="color: #fccc66; line-height: 30px">
          主要城市平均销售价格（元）
        </div>
        <price-city-radar></price-city-radar>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <policy-carousel></policy-carousel>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import SupplyTrend from './supply-trend.vue'
import PriceCityRadar from './price-city-radar.vue'
import SupplyCityRank from './supply-city-rank.vue'
import PolicyCarousel from './policy-carousel.vue'
export default {
  components: {
    SupplyTrend,
    PriceCityRadar,
    SupplyCityRank,
    PolicyCarousel,
  },
  data() {
    return {}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/market-zone/index.vue